export default __webpack_public_path__ + "static/media/2.58182d2f.jpg";